// Validacao de NCM — a regra e do SCHEMA da SEFAZ, nao nossa.
//
// O XSD oficial da NF-e 4.00 (leiauteNFe_v4.00.xsd, elemento <NCM>) traz o pattern
// `[0-9]{2}|[0-9]{8}`: DOIS digitos (o genero, permitido fora de comercio exterior)
// ou OITO. Qualquer outro tamanho derruba o LOTE inteiro antes de individualizar a
// nota, e a SEFAZ responde cStat 225 "Falha no Schema XML" — codigo generico que
// NAO diz qual campo esta errado.
//
// Caso real que gerou este modulo (02/09/2026): o produto 965 "CJ 1INT SIMPLES 10A
// LIZ" tinha NCM `853650` — SEIS digitos, digitado a mao no preenchimento fiscal do
// cadastro entre 11/04 e 30/05/2026. Ficou dormindo 4 meses porque nenhuma nota
// jamais precisou dele; na primeira venda com NFC-e (29/08) a nota foi recusada duas
// vezes com 225, e o motivo que a tela mostrava nao apontava o campo.
//
// ⚠️ VAZIO e um estado SEPARADO de invalido, de proposito: um produto pode existir no
// cadastro sem NCM (ainda nao classificado), e a ficha nao trava por isso. Quem
// recusa vazio e a EMISSAO — ver `emitirNfce`/`emitirNfe`, que ja o faziam.

export type EstadoNcm = 'vazio' | 'invalido' | 'valido';

/** So os digitos: aceita `8536.50.90`, `8536 50 90`, `85365090` -> `85365090`. */
export function digitosNcm(bruto: string | null | undefined): string {
  return String(bruto ?? '').replace(/\D/g, '');
}

export function avaliarNcm(bruto: string | null | undefined): EstadoNcm {
  const d = digitosNcm(bruto);
  if (!d) return 'vazio';
  return d.length === 2 || d.length === 8 ? 'valido' : 'invalido';
}

/**
 * Frase pronta pro operador quando o NCM nao passa. Devolve `null` quando esta valido.
 *
 * ⚠️ Diz o TAMANHO ENCONTRADO: sem isso a mensagem vira "NCM invalido", que e tao
 * generica quanto o 225 que ela existe pra evitar.
 */
export function motivoNcmInvalido(bruto: string | null | undefined): string | null {
  const estado = avaliarNcm(bruto);
  if (estado === 'valido') return null;
  const d = digitosNcm(bruto);
  if (estado === 'vazio') return 'NCM nao preenchido.';
  return `NCM com ${d.length} digito${d.length === 1 ? '' : 's'} (${d}) — a SEFAZ so aceita 8 digitos (ou 2, para o genero).`;
}
